export const NOTIFICATION_RULES_PERMISSION = "notification_rule:read"

export const CREATE_RULES_PERMISSION = "notification_rule:create"

export const UPDATE_RULES_PERMISSION = "notification_rule:update"

export const DELETE_RULES_PERMISSION = "notification_rule:delete"
